import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
// import ReactDOM from "react-dom";
import ReactDOM from 'react-dom/client';
import store, { persistor } from "./app/store/store";
import axios from "axios";
import { setupAxios } from "./app/utils/AuthUtils";
import App from "./App";
import "./index.scss";
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const { PUBLIC_URL } = process.env;

// Interceptador do axios para verificar
// se possui token e configurar header.
setupAxios(axios, store);

// ReactDOM.render(<App store={store} persistor={persistor} basename={PUBLIC_URL} />, document.getElementById("root"));
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<App store={store} persistor={persistor} basename={PUBLIC_URL} />
);

serviceWorkerRegistration.register();
